import { render, staticRenderFns } from "./qualityAuditConfig.vue?vue&type=template&id=60c645c4&scoped=true&"
import script from "./qualityAuditConfig.vue?vue&type=script&lang=js&"
export * from "./qualityAuditConfig.vue?vue&type=script&lang=js&"
import style0 from "./qualityAuditConfig.vue?vue&type=style&index=0&id=60c645c4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c645c4",
  null
  
)

export default component.exports